<template>
  <Dialog v-bind:visible="$parent.dialogOpen" :closable="false" modal :draggable="false"
    header="Eine Gruppe Erstellen" class="cua-modal" style="max-width: 30rem;">
    <span class="cua-modal-text">Erstelle eine neue Benutzergruppe.</span>
    <div class="cua-modal-inputs">
      <FloatLabel>
        <InputText id="groupname" type="text" v-model="groupname" class="cua-modal-btn"></InputText>
        <label for="groupname">Gruppenname</label>
      </FloatLabel>
      <FloatLabel>
        <InputText id="groupweight" type="number" v-model="groupweight" class="cua-modal-btn" ></InputText>
        <label for="groupweight">Gruppengewicht</label>
      </FloatLabel>
      <FloatLabel class="cua-modal-btn" variant="on">
    <MultiSelect class="cua-modal-btn" id="on_label" v-model="selectedPermissions" :options="permissions" :maxSelectedLabels="1" optionLabel="description" />
    <label for="on_label">Berechtigungen</label>
</FloatLabel>
    </div>
    <Divider></Divider>
    <div class="cua-modal-btns">
      <Button class="cua-modal-btn" :loading="loading" icon="fa-solid fa-check" @click="createGroup"
        severity="success" label="Gruppe Erstellen"></Button>
      <Button class="cua-modal-btn" :disabled="loading" on="fa-solid fa-cancel" @click="close" severity="danger" text
        outlined label="Abbrechen"></Button>

    </div>
  </Dialog>
</template>
<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from "primevue/floatlabel"
import InputSwitch from 'primevue/inputswitch'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'
import Divider from 'primevue/divider'
import MultiSelect from 'primevue/multiselect';

export default {
  components: {
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch,
    Divider,
    MultiSelect
  },

  data() {
    return {
      groupname: null,
      groupweight: null,
      loading: false,
      selectedPermissions: [],
      permissions: [],
    }
  },

  methods: {
    async createGroup() {

      this.loading = true

      if (this.groupname == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erstellung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst ein Gruppennamen angeben.',
          life: 5000
        })

        this.loading = false;

        return;
      }

      if (this.groupweight == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erstellung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst ein Gruppengewicht angeben.',
          life: 5000
        })

        this.loading = false;

        return;
      }

      let response = await axios.post(config.api_url + '/api/management/groups/create', {
        groupname: this.groupname,
        permissions: this.selectedPermissions,
        groupweight: this.groupweight,
      },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          },

        })


      if (response.status == 201) {
        this.$parent.fetchData()
        this.close()
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Fehlermeldung',
          group: "tc",
          detail:
            response.data,
          life: 5000
        })
      }
      this.loading = false;
    },
    close() {
      this.$parent.dialogOpen = false;
    }
  },

  async mounted() {
    let Permsresponse = await axios.post(config.api_url + '/api/getPermissions', {
      },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          },

        })

        if(Permsresponse.status == 200) {
          this.permissions = Permsresponse.data; 
        }
   }
}
</script>
<style lang="scss" scoped>
.cua-modal {
  &-text {
    color: var(--gray-400);
  }

  &-inputs {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.9rem;
  }

  &-btns {
    display: flex;
    gap: 0.5rem;
    position: relative;
  }

  &-switch {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding-bottom: 1rem;

    &-s {
      width: 3.2rem;
    }
  }

  .p-float-label .p-multiselect {
    width: 81%;
  }
}

</style>
